module.exports = __webpack_public_path__ + "static/img/drive-tag.5c8b5386.png";